import { CREATE_ACTIVITY, UPDATE_ACTIVITY, DELETE_ACTIVITY } from '@common/constants/webSockets'
import { IActivityData } from '@common/interfaces/activity'
import { combineReducers } from 'redux'
import { createLoadingDataReducer } from '../../helpers/redux'
import * as actions from './actions'

export default combineReducers({
  activities: createLoadingDataReducer<IActivityData>(
    [actions.LIST_ACTIVITY_REQUEST],
    [
      actions.CREATE_ACTIVITY_REQUEST,
      actions.UPDATE_ACTIVITY_REQUEST,
      actions.DELETE_ACTIVITY_REQUEST,
      CREATE_ACTIVITY,
      UPDATE_ACTIVITY,
      DELETE_ACTIVITY,
    ],
    true,
    undefined,
    // Merge, not replace: the websocket reload lacks the list-only totalCollections
    // that Wire/Check rows show as their Amount.
    true,
  ),
})
